import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core'
import { Router } from '@angular/router'
import { FilterModel, FilterOptionModel, LinkModel, SearchModel } from '@flocasts/experience-service-types'
import { isFilterModel, isLinkModel } from 'src/app/shared/functions/type-guards'
import { SearchFiltersService } from 'src/app/singleton-services/search-filters.service'

@Component({
  selector: 'flo-search-filters',
  templateUrl: './search-filters.component.html',
  styleUrls: ['./search-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFiltersComponent implements OnChanges {
  @Input() searchModel: SearchModel
  @Input() filters: ReadonlyArray<FilterModel | LinkModel>
  @Input() isToggleOn = false
  @Input() filterByAction = false
  @Input() searchByAction = false
  clearAll?: LinkModel
  dropdowns: Array<FilterModel>
  toggleFilter?: FilterModel

  constructor(private searchFiltersService: SearchFiltersService, private readonly router: Router) {}

  /**
   * This emits when dropdown or toggle is selected.
   * If filterByAction is set, we router navigate to the vanity url provided by the BFF.
   * Otherwise, we update the url with facets query params.
   * @param option The dropdown or toggle option.
   */
  public handleSingleFilterClicked(option: FilterOptionModel) {
    if (this.filterByAction) {
      if (option.action?.url) this.router.navigateByUrl(option.action?.url)
    } else {
      this.searchFiltersService.updateQueryParams({ facets: option.facets })
    }
  }

  public handleSearch(event: { searchTerm: string | null; searchModel?: SearchModel }) {
    if (this.searchByAction) {
      const vanityUrl = event.searchModel?.action?.url
      const searchUrl =
        !!vanityUrl && !!event.searchTerm
          ? `${vanityUrl.includes('?') ? vanityUrl + '&' : vanityUrl + '?'}search=${event.searchTerm}`
          : vanityUrl
      if (!!searchUrl) this.router.navigateByUrl(searchUrl)
    } else {
      this.searchFiltersService.updateQueryParams({ search: event.searchTerm })
    }
  }

  public handleClearAllClicked() {
    this.searchFiltersService.isFilterOrSearchLoading$.next(true)
  }

  ngOnChanges() {
    if (this.filters) {
      this.clearAll = this.filters.filter(filter => filter.id === 'clear-all').find(isLinkModel)
      this.dropdowns = this.filters.filter(filter => filter.style === 'dropdown').filter(isFilterModel)
      this.toggleFilter = this.filters.filter(filter => filter.style === 'toggle').find(isFilterModel)
    }
  }
}
